<template>
  <v-app>
    <NavigationHeaderDefault :mini="mini" @toggle-sidebar="toggleSidebar" />
    <v-main class="grey lighten-4" style="padding: 0;">
      <div style="display: flex; flex-direction: row; height: calc(100vh - 64px); overflow: hidden;">
        <Sidebar :drawer.sync="drawer" :miniVariant.sync="mini" />
        <div id="main-layout" style="flex: 1; display: flex; flex-direction: column; overflow: hidden;">
          <div style="flex: 1; overflow-y: auto; padding: 16px;">
            <AppContent />
          </div>
        </div>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import NavigationHeaderDefault from './Partials/NavigationHeaderDefault.vue'
import Sidebar from './Sidebar.vue'
import AppContent from './Content.vue'

export default {
  components: {
    NavigationHeaderDefault,
    Sidebar,
    AppContent
  },
  data() {
    return {
      // null = biarkan Vuetify yang memutuskan berdasar lebar layar:
      // terbuka di >= 1264px (lg), tertutup di bawahnya. Jangan baca
      // $vuetify.breakpoint di data() — nilainya belum akurat sebelum mount.
      drawer: null,
      mini: false
    }
  },
  created() {
    const token = localStorage.getItem('token')
    if (!token) {
      this.$router.push('/')
    }
  },
  mounted() {
    // breakpoint sudah akurat di sini
    this.mini = this.$vuetify.breakpoint.lgAndUp;
  },
  methods: {
    toggleSidebar() {
      if (this.$vuetify.breakpoint.lgAndUp) {
        this.mini = !this.mini;
      } else {
        this.drawer = !this.drawer;
      }
    }
  }
}
</script>
